
































































































import Vue from "vue";
import { dataTableItemsPerPage } from "@/utility/Constants";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import GlobalStatusInstallationChip from "@/views/App/Components/chips/GlobalStatusInstallationChip.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";

//Model
import { Installation } from "@/model/data/Installation";
import { mapState } from "vuex";
import { findParentNodesFromInstallationName } from "@/utility/TreeviewUtility";

export default Vue.extend({
    components: {
        TableFiltersRow,
        GlobalStatusInstallationChip,
        DeviceModelChip,
        ColumnVisibilityFilter,
    },
    props: {
        installations: Array as () => Array<Installation>,
        paginatedTotalItems: Number,
        loading: Boolean,
        deleteLoading: Boolean,
    },
    data() {
        return {
            installationToDelete: [],
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            dataTableItemsPerPage,
            availableHeaders: [],
            options: {},
            ignoreOptionsChanges: false,
            search: "",
            initialAvailableHeaders: [
                {
                    enabled: true,
                    text: this.$t("common.name"),
                    value: "name",
                },
                {
                    enabled: false,
                    text: this.$t("platformMaintenance.foldersPath"),
                    value: "parentFolder",
                },
                {
                    enabled: false,
                    text: this.$t("common.tags"),
                    value: "tags",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                },
                {
                    enabled: false,
                    text: this.$t("device_status.pc_name"),
                    value: "connectedPc",
                },
                {
                    enabled: true,
                    text: this.$t("common.last_update"),
                    value: "lastMessage",
                },
                {
                    enabled: true,
                    text: this.$t("common.device/s"),
                    value: "machines",
                    sortable: false,
                },
            ],
            filters: [
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                },
            ],
        };
    },
    computed: {
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
        }),
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
    },
    methods: {
        findParentNodesFromInstallationName,
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
            }
        },
        onDelete() {
            this.$emit(
                "delete",
                this.installationToDelete.map((inst) => inst.name)
            );
        },
        getFoldersPath(installationName) {
            if (installationName) {
                let result = this.findParentNodesFromInstallationName(this.deviceTree, installationName);
                return result
                    .map((o) => o.name)
                    .join("/")
                    .replace("//", "/");
            }
            return "";
        },
    },
});
